// extracted by mini-css-extract-plugin
export default {"orderHeader":"Suscriptions_orderHeader__L+Swq","button":"Suscriptions_button__e-FPy","productsContainer":"Suscriptions_productsContainer__HhYtw"};